import initGoogleMaps from './googleMaps';

export default initGoogleMaps;



// WEBPACK FOOTER //
// ./scripts/utils/googleMaps/index.js